import React from "react";
import { IGame } from "../interfaces/intefaces"

interface IProps {
    game: IGame
    handleGameClick: (game: IGame, loginRequired?: boolean, for_fun?:boolean) => boolean
}
const Game = ({ game, handleGameClick }: IProps) => {

    return (
        <div key={game.id} className="game">
            {game.hot && (<span className="tag tag_hot"></span>)}
            {game.new_game && (<span className="tag tag_new"></span>)}
            <div>
                <span className="img-wrap">
                    <img src={game.game_main_image[0]} alt={game.post_title} />
                    <span onClick={() => handleGameClick(game)} className="btn-wrap">PLAY</span>
                    {game.for_fun_supported && (<span onClick={() => handleGameClick(game, false, game.for_fun_supported)} className="btn-wrap  btn-for-fun">PLAY FOR FUN</span>)}
                </span>
                <span className="title">{game.post_title}</span>
                <span className="provider-title">{game.game_provider_name}</span>
            </div>
        </div>
    )
}

export default Game;
